// src/components/Layout/Layout.jsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, AppBar, Toolbar, IconButton, Typography, Container } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from './Sidebar'; 
import { useAuth } from '../../context/AuthContext';

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // If not authenticated, don't render the layout
  if (!isAuthenticated) {
    return <Outlet />;
  }

  return (
    <Box sx={{ display: 'flex', height:'100vh',width:'100%'}}>
      {/* Sidebar */}
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} />

      {/* Main content */}
      <Box
        component="main"
        className='main-content'
         sx={{
            flexGrow: 1,
            width: { xs: '100%', md: 'calc(100% - 300px)' },
            overflowX: 'auto',
            display: 'flex',
            flexDirection: 'column'
          }}
      >
        {/* Mobile app bar */}
        <AppBar
          position="fixed"
          sx={{
            display: { xs: 'block', sm: 'block', md: 'block', lg: 'none',xl:'none'},
          }}
        >

          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              FNTIS Booking
            </Typography>
          </Toolbar>
        </AppBar>
        
        {/* Toolbar spacer for mobile */}
        <Toolbar sx={{ display: { xs: 'block',lg:'none',sm: 'none' } }} />
        
        {/* Page content */}
        <Container 
        className='main-container' 
        maxWidth={false}
        sx={{
        mt: 4,
        mb: 4,
        px: 0,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default Layout;